export class OverrideDataClassificationsRequest {
    'dataClasses';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "dataClasses",
            "baseName": "dataClasses",
            "type": "Array<DataClass>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return OverrideDataClassificationsRequest.attributeTypeMap;
    }
    constructor() {
    }
}
